import { render, staticRenderFns } from "./TxParams.vue?vue&type=template&id=9c8e238a&scoped=true&"
import script from "./TxParams.vue?vue&type=script&lang=ts&"
export * from "./TxParams.vue?vue&type=script&lang=ts&"
import style0 from "./TxParams.vue?vue&type=style&index=0&id=9c8e238a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8e238a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
